export  enum VendorCommandsEnum {
    TOGGLE_SOUND_CONTROLLER = "TOGGLE_SOUND_CONTROLLER",
    TOGGLE_SOUND_BUTTON = "TOGGLE_SOUND_BUTTON",
    TOGGLE_MASTER_SOUND_BUTTON = "TOGGLE_MASTER_SOUND_BUTTON",
    UPDATE_JACKPOTS = "UPDATE_JACKPOTS",
    TOGGLE_JACKPOTS_BUTTON = "TOGGLE_JACKPOTS_BUTTON",
    SHOW_INSUFFICIENT_FUNDS_MESSAGE = "SHOW_INSUFFICIENT_FUNDS_MESSAGE",
    TOGGLE_SWIPE_TO_SPIN = "TOGGLE_SWIPE_TO_SPIN",
    TOGGLE_SKIP_INTRO = "TOGGLE_SKIP_INTRO",
    TOGGLE_STOP_ON_ANY_WIN = "TOGGLE_STOP_ON_ANY_WIN",
    SKIP_FREE_GAMES = "SKIP_FREE_GAMES",
    CANCEL_FREE_GAMES = "CANCEL_FREE_GAMES",
    GAME_PAUSED = "GAME_PAUSED",
    TOGGLE_GAME_INFO = "TOGGLE_GAME_INFO",



    INITIALIZE_API = "INITIALIZE_API",
    CONFIGURE = "CONFIGURE",
    GAME_LOAD_STARTED = "GAME_LOAD_STARTED",
    GAME_LOAD_PROGRESS = "GAME_LOAD_PROGRESS",
    GAME_LOAD_COMPLETED = "GAME_LOAD_COMPLETED",
    BALANCE_UPDATE = "BALANCE_UPDATE",
    AUTOPLAY_STARTED = "AUTOPLAY_STARTED",
    AUTOPLAY_FINISHED = "AUTOPLAY_FINISHED",
    WIN_UPDATE = "WIN_UPDATE",
    BET_UPDATE = "BET_UPDATE",
    DREAM_DROP_ENDED = "DREAM_DROP_ENDED",
    GAME_ROUND_STARTED = "GAME_ROUND_STARTED",
    GAME_ROUND_ENDED = "GAME_ROUND_ENDED",
    SEND_USER_ACTION = "SEND_USER_ACTION",
    SHOW_HISTORY = "SHOW_HISTORY",
    FAST_PLAY_ACTIVATED = "FAST_PLAY_ACTIVATED",
    FEATURE_STARTED = "FEATURE_STARTED",
    FEATURE_FINISHED = "FEATURE_FINISHED",
    TOGGLE_FEATURE_SPIN_POPUP = "TOGGLE_FEATURE_SPIN_POPUP",
    FEATURE_BUTTON_OPTIONS = "FEATURE_BUTTON_OPTIONS",
    CHANGED_BET = "CHANGED_BET"
}
